export const GridToolsTypes = {
    SET_TOOL_MODE : 'SET_DRAW_MODE_GRIDTOOLS',
    SET_SNAP_MODE : 'SET_SNAP_MODE_GRIDTOOLS',
    SET_TOOL_PROPERTIES : 'SET_TOOL_PROPERTIES_GRIDTOOLS',
    SET_SELECTED_GRID : 'SET_SELECTED_GRID_GRIDTOOLS',
    SET_ACTIVE_GRID : 'SET_ACTIVE_GRID_GRIDTOOLS',
    SET_PROPS_GRID : 'SET_PROPS_GRID_GRIDTOOLS',
    SET_LAYERS : 'SET_LAYERS_GRIDTOOLS',
    SET_SELECTED_LAYER : 'SET_SELECTED_LAYER_GRIDTOOLS',
    SET_SHAPE_SELECTED : 'SET_SHAPE_SELECTED_GRIDTOOLS',
    SET_LOADED_GRID : 'SET_LOADED_GRID_GRIDTOOLS',
    SET_SYNC_RENDER_GRID : 'SET_SYNC_RENDER_GRID_GRIDTOOLS',
    SET_SYNC_RENDER_OPERATION_GRID : 'SET_SYNC_RENDER_OPERATION_GRID_GRIDTOOLS',
    SET_SYNC_PROPS_GRID : 'SSET_SYNC_PROPS_GRID_GRIDTOOLS',
    SIGNAL_GRID : 'SIGNAL_GRID_GRIDTOOLS',
    SIGNAL_CLEAR_GRID : 'SIGNAL_CLEAR_GRID_GRIDTOOLS',
    MEASURE_GRID : 'MEASURE_GRID_GRIDTOOLS',
    MEASURE_CLEAR_GRID : 'MEASURE_CLEAR_GRID_GRIDTOOLS',
    MOVING_GRID : 'MOVING_GRID_GRIDTOOLS',
    PROPAGATE_CHANGES_GRID : 'PROPAGATE_CHANGES_GRID_GRIDTOOLS',
    ZOOM_CHANGE: 'ZOOM_CHANGE_GRIDTOOLS',
    CENTER_CHANGE: 'CENTER_CHANGE_GRIDTOOLS',
    SET_TOKEN_PRESENCE: 'SET_TOKEN_PRESENCE_GRIDTOOLS',
    DICE_3D_STATE_TOGGLE: 'DICE_3D_STATE_TOGGLE_GRIDTOOLS',
    RESET : 'RESET'
};